import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: "/map",
    name: "map",
    component: () => import('../views/Map.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Count client-side navigations in GoatCounter (the script tag in index.html
// only fires on the initial page load).
router.afterEach((to) => {
  if (!window.goatcounter || !window.goatcounter.count) return
  window.goatcounter.count({
    path: to.fullPath,
    title: document.title,
    event: false
  })
})

export default router
